export default {
  getLocaleBrowser: () => navigator.language.split('-')[1] ? navigator.language.split('-')[0] : navigator.language || 'en-US',
  getHostnameBrowser: () => window.location.hostname.split('.')[0],
  getOriginBrowser: () => window.location.origin,
  getDefaultLanguage: () => 'en-US',
  camelize: (str) => {
      return str.replace(/\W+(.)/g, function(match, chr) {
        return chr.toUpperCase();
      });
    }
}
